module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"modalheader":"Detalhes do parcelamento"},"en-US":{"modalheader":"Installments details"}}')
  delete Component.options._Ctor
}
